import React from 'react';
import { useLocation } from 'react-router-dom';
import { PATHS } from 'controller/constants';
import useTokenExpiry from './useTokenExpiry';

const TokenExpiryWrapper = ({ children }) => {
    const location = useLocation();
    const isLoginRoute = location.pathname === PATHS.LOGIN;

    // Always call the hook, but make it no-op for the login route
    useTokenExpiry(isLoginRoute);

    return children; // Always render children
};

export default TokenExpiryWrapper;
